module.exports = __webpack_public_path__ + "img/Container (7).dfd02a1c.png";